import {
  AktEuFilter,
  AktEuFilterListApi,
  AktEuFilterListItem,
  AktEuFilterListPage,
  SortDirectionEnum,
} from 'sprava-aktov-eu-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { spravaAktovEuPrefixPath } from '../configuration/apiConfigurationConstants';
import NavrhAktuEuFilter from '../../model/NavrhAktuEuFilter';
import NavrhAktuEuListItem from '../../model/NavrhAktuEuListItem';
import { ClientResponse } from '../../model/ClientResponse';
import NavrhAktuEuListPage from '../../model/NavrhAktuEuListPage';
import dateToString from '../../function/dateToString';

const client = new AktEuFilterListApi(apiConfiguration(spravaAktovEuPrefixPath));

const mapAktEu = (data: AktEuFilterListItem): NavrhAktuEuListItem => ({
  uuid: data.uuid,
  identifikatorAktu: data.aktId,
  institucia: data.institucia,
  nazovAktu: data.nazovAktu,
  nazovLegislativnehoMaterialu: data.nazovLegislativnehoMaterialu,
  datumPrijatiaAktu: data.datumPrijatiaAktu ? new Date(data.datumPrijatiaAktu) : undefined,
});

const map = (data: AktEuFilterListPage): NavrhAktuEuListPage => ({
  aktEuList: data.aktEuList ? data.aktEuList.map(aktEu => mapAktEu(aktEu)) : [],
  number: data.number,
  size: data.size,
  totalElements: data.totalElements,
});

const mapAktEuFilter = (data: NavrhAktuEuFilter): AktEuFilter => ({
  hladanyVyraz: data.hladanyVyraz,
  nazovAktu: data.nazovAktu,
  nazovLegislativnehoMaterialu: data.nazovLegislativnehoMaterialu,
  cisloLegislativnehoMaterialu: data.cisloLegislativnehoMaterialu,
  aktId: data.identifikatorAktu,
  typAktuUuid: data.type?.uuid,
  instituciaUuid: data.institucia?.uuid,
  medziinstitucionalnyKod: data.medziinstitucionalnyKod,
  datumPrijatiaAktuOd: data.datumPrijatiaAktuOd ? dateToString(data.datumPrijatiaAktuOd) : undefined,
  datumPrijatiaAktuDo: data.datumPrijatiaAktuDo ? dateToString(data.datumPrijatiaAktuDo) : undefined,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchAktEuListPage = async (
  filter: NavrhAktuEuFilter,
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
):
  Promise<ClientResponse<NavrhAktuEuListPage>> => {
  const {
    data,
    status,
  } = await client.getAktEuFilteredList(
    mapAktEuFilter(filter),
    page,
    size,
    sortBy,
    sortDirection,
  );
  return {
    data: map(data),
    responseCode: status,
  };
};
